// Quarentena do intake público (`lead_rejections`): envios que passaram no
// Turnstile mas caíram no honeypot ou no time-trap de `submit-lead`. Só admin
// lê/apaga (RLS); restaurar passa pela RPC `restore_lead_rejection`, que cria
// o lead e remove a rejeição na mesma transação.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";

export type LeadRejection = Tables<"lead_rejections">;

const KEY = ["lead-rejections"] as const;

export function useLeadRejections() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<LeadRejection[]> => {
      const { data, error } = await supabase
        .from("lead_rejections")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(200);
      if (error) throw error;
      return data ?? [];
    },
  });
}

/** Resolves to the id of the lead created from the rejection. */
export function useRestoreLeadRejection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string): Promise<string> => {
      const { data, error } = await supabase.rpc("restore_lead_rejection", { p_id: id });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      qc.invalidateQueries({ queryKey: ["leads"] });
    },
  });
}

export function useDeleteLeadRejection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from("lead_rejections").delete().eq("id", id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
